import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { ErrorHead } from '@layouts/Error-Head';
import { Header } from './Header';
import { Footer } from './Footer';

export const ErrorHelpLayout = ({ title, children, isHidePage = false, meta = null, isDarkMode = false }) => (
  <>
    <GlobalStyle />
    <ErrorHead title={title} isHidePage={isHidePage} meta={meta} />
    <Header isDarkMode={isDarkMode} />
    <main>{children}</main>
    <div id="modal" />
    <Footer />
  </>
);

const GlobalStyle = createGlobalStyle`
  body {
    min-width: 320px;
    background-color: #fff;
  }
`;
